var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white--text primary darken-1 discount-label",style:({backgroundColor: _vm.color})},[_c('span',{staticClass:"discount-number"},[_vm._v("-"+_vm._s(_vm.discount)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }